var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8465 44.4785H35.4387C36.8133 44.4785 38.0311 43.6546 38.5436 42.3795L40.1553 38.3633",
    stroke: "#0095DF",
    strokeWidth: 1.46486,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8465 47.493H35.4387C38.0512 47.493 40.3673 45.9274 41.341 43.5028L43.438 38.2788",
    stroke: "#0095DF",
    strokeWidth: 1.46486,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6198 38.2645L42.2023 38.496C42.7736 38.5331 43.3416 38.3839 43.8209 38.0708C44.3003 37.7577 44.6652 37.2976 44.8608 36.7596L45.5893 34.7577M43.2541 25.5309L46.1471 27.6575C46.6084 27.9964 46.9474 28.4757 47.1135 29.0235C47.2795 29.5713 47.2636 30.1581 47.0682 30.6962L46.7848 31.4746",
    stroke: "#0095DF",
    strokeWidth: 1.46486,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.725 22.731C42.9779 23.1869 43.6239 24.5723 43.1679 25.8252L38.7424 37.9841C38.2864 39.237 36.9011 39.883 35.6482 39.427C34.3954 38.9711 33.7494 37.5857 34.2053 36.3329L38.6309 24.1739C39.0868 22.9209 40.4722 22.2749 41.725 22.731Z",
    stroke: "#0095DF",
    strokeWidth: 1.46486,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9308 49.2675C30.743 49.2675 32.2121 47.7984 32.2121 45.9862C32.2121 44.1739 30.743 42.7048 28.9308 42.7048C27.1185 42.7048 25.6494 44.1739 25.6494 45.9862C25.6494 47.7984 27.1185 49.2675 28.9308 49.2675Z",
    stroke: "#0095DF",
    strokeWidth: 1.46486,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3154 39.3504H13.8233L20.3806 44.9608C21.2588 45.7122 22.6139 45.0885 22.6139 43.9329V39.3505H26.952C29.5136 39.3505 31.5893 37.2738 31.5893 34.7131V22.133C31.5893 19.5714 29.5136 17.4946 26.952 17.4946H6.20503C3.64436 17.4946 1.56769 19.5713 1.56769 22.133V34.7129C1.56769 37.2736 3.64436 39.3503 6.20503 39.3503H7.82272M6.39439 25.7604H26.7629M6.39439 29.3352H26.7629M6.39439 32.9099H23.4309",
    stroke: "#0095DF",
    strokeWidth: 1.46486,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.89273 17.6832C5.82282 13.7444 7.82859 10.1289 10.7625 7.19497C14.9309 3.02765 20.4724 0.732422 26.3661 0.732422C32.2598 0.732422 37.8014 3.02765 41.9698 7.19497C46.1371 11.3634 48.4323 16.9048 48.4323 22.7986C48.4323 25.2705 48.0182 27.7154 47.2169 30.0286",
    stroke: "#0095DF",
    strokeWidth: 1.46486,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04419 17.4947C10.3474 9.55017 17.6902 3.7262 26.3662 3.7262C36.8824 3.7262 45.4386 12.2824 45.4386 22.7986C45.4386 24.1512 45.2951 25.5 45.0105 26.8223",
    stroke: "#0095DF",
    strokeWidth: 1.46486,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.cc9a5c12ac9595cbb5a48743031645bc.svg";
export { ForwardRef as ReactComponent };